import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useAppSelector } from '../../../app/hooks/hooks';
import { RentalServicesText } from '../../../Constants/Constants';
import { StageNames } from '../../../types/type';

export default function ClaimDetailRental() {
  const rentalInfo = useAppSelector((state) => state.services.eligibleRentalService);
  const shopInfo = useAppSelector((state) =>
    state.claimDetail.claimSummary?.serviceProviderInfo?.filter(
      (provider) => provider.serviceTypeName === StageNames.RENTAL
    )
  );

  const rentalNotAvailable = !rentalInfo;
  const rentalFullyEligible =
    !!rentalInfo &&
    rentalInfo.serviceDependenciesSatisfied &&
    !rentalInfo.serviceCustomerCallInMsgCode &&
    !rentalInfo.serviceOpen;
  const rentalPartiallyEligible = !!rentalInfo && !rentalFullyEligible && !rentalInfo.serviceOpen;

  function getRentalBodyMessage() {
    if (rentalFullyEligible) return RentalServicesText.rentalFullyEligibleAccordionText;
    if (rentalPartiallyEligible) return RentalServicesText.bodyRentalEligibleContactToConfirm;
    if (rentalNotAvailable) return RentalServicesText.bodyRentalNotCoveredContactToReserve;
    return undefined;
  }
  const rentalBodyMessage = getRentalBodyMessage();

  return (
    <Grid container sx={{ marginTop: '1rem' }}>
      {/*
       * No Rental Coverage or Has Rental coverage but not fully eligible
       */}
      {!!rentalBodyMessage && (
        <Grid item xs={12}>
          <Typography variant="body1" sx={{ m: '1rem' }}>
            {rentalBodyMessage}
          </Typography>
        </Grid>
      )}

      {/*
       * Has Rental info and open for service
       */}
      {!!shopInfo && shopInfo.length > 0 && (
        <Grid container sx={{ m: '1rem' }}>
          <Grid item xs={12}>
            <Typography variant="body1">
              <b>Car Return Location</b>
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ mt: '1rem' }}>
            <Typography variant="body1">{shopInfo[0].providerName}</Typography>
            <Typography variant="body1">{shopInfo[0].providerAddress}</Typography>
          </Grid>
        </Grid>
      )}

      {/*
       * Show Rental limits
       */}
      {!!rentalInfo && !!rentalInfo.coverageDescription && (
        <Grid container>
          <Grid item xs={8}>
            <Typography variant="body1" sx={{ ml: '1rem' }}>
              <b>Rental Limits</b>
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body1" sx={{ mr: '3rem', textAlign: 'right' }}>
              {rentalInfo.coverageDescription.split('/')[0]} <br />
              {rentalInfo.coverageDescription.split('/')[1]} <br />
            </Typography>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
